/*jQuery(document).ready(function($) {

});*/

(function ($, Drupal) {
  Drupal.behaviors.childrenFilters = {
    attach: function (context, settings) {
      /*** Select Children filter ***/
      $('.view-view-children .view-filters select').selectric()

      $('#block-views-view-children-children-list').on('click', '.view-view-children .view-filters .views-widget-filter-show_filters .mhg-btn-filter', (e) => {
        e.preventDefault()

        const wrapFormEl = $('.view-view-children .view-filters .views-exposed-form')
        const containerEl = $('.view-view-children .view-filters .views-exposed-widgets')
        const blockcontainer = $('#block-views-view-children-children-list')

        if( blockcontainer.hasClass('open-dropdown') ){
          // containerEl.removeClass('open-dropdown')
          // wrapFormEl.removeClass('open-dropdown')
          blockcontainer.removeClass('open-dropdown')
        }else{
          // containerEl.addClass('open-dropdown')
          // wrapFormEl.addClass('open-dropdown')
          blockcontainer.addClass('open-dropdown')
        }
      })
      /*--------------------------------------------------------------------------------------------------*/
    }
  }
})(jQuery, Drupal);



// WEBPACK FOOTER //
// ./src/children_filter.js